import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "webapp-popup"
}
const _hoisted_2 = { class: "popup-main blur" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "pwa-desc" }
const _hoisted_7 = { class: "popup-footer" }
const _hoisted_8 = { class: "flex justify-center" }
const _hoisted_9 = { class: "popup-main" }
const _hoisted_10 = { class: "popup-header" }
const _hoisted_11 = { class: "popup-title" }
const _hoisted_12 = { class: "popup-content" }
const _hoisted_13 = { class: "ios-guide-section" }
const _hoisted_14 = { class: "guide-step-image-wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "ios-guide-section" }
const _hoisted_17 = { class: "guide-step-image-wrap" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "guide-step-text-group2" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { class: "app-link" }
const _hoisted_23 = ["src"]

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSettingsStore } from '@/store'
import { usePWA } from '@/hooks';


export default {
  __name: 'IOSWebApp',
  setup(__props) {

const { installPWA } = usePWA();

const settingsStore = useSettingsStore()
const { canPWA, showIOSWebApp } = storeToRefs(settingsStore);

const appLink = ref(window.location.origin)
const showIOSPopup = ref(false)

const doInstall = () => {
  if (canPWA.value) {
    settingsStore.hideIOSWebApp(); 
    installPWA();
  } else {
    showIOSPopup.value = true;
  }
}

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_unref(showIOSWebApp))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_popup, {
          show: !showIOSPopup.value,
          position: "bottom",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createVNode(_component_van_icon, {
                  class: "close-icon",
                  name: "clear",
                  onClick: _cache[0] || (_cache[0] = $event => (_unref(settingsStore).hideIOSWebApp()))
                }, null, 512), [
                  [_directive_audio, void 0, "close"]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_van_image, {
                    class: "logo-img",
                    src: require('@/assets/img/common/logo.png')
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('pwa.ios.desc')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "continue-use",
                  onClick: _cache[1] || (_cache[1] = $event => (_unref(settingsStore).hideIOSWebApp()))
                }, _toDisplayString(_ctx.$t('pwa.continueH5')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                    class: "bottom-btn",
                    onClick: _cache[2] || (_cache[2] = $event => {doInstall();})
                  }, {
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("svg", {
                        viewBox: "0 0 40 40",
                        fill: "#1678ff",
                        class: "bottom-btn-icon"
                      }, [
                        _createElementVNode("g", { "clip-path": "url(#a2hs-ios_svg__clip0_98_44)" }, [
                          _createElementVNode("path", { d: "M38.287 31.172a21.694 21.694 0 01-2.17 3.867c-1.14 1.612-2.075 2.728-2.795 3.348-1.117 1.017-2.313 1.538-3.593 1.568-.92 0-2.028-.26-3.319-.786-1.295-.523-2.485-.782-3.573-.782-1.141 0-2.365.259-3.674.782-1.311.526-2.367.8-3.175.828-1.228.051-2.452-.484-3.674-1.61-.78-.674-1.755-1.83-2.924-3.467-1.253-1.748-2.284-3.775-3.092-6.086C5.434 26.338 5 23.92 5 21.58c0-2.68.585-4.992 1.755-6.93a10.25 10.25 0 013.677-3.685 9.958 9.958 0 014.97-1.39c.975 0 2.254.3 3.844.887 1.585.59 2.603.889 3.05.889.333 0 1.463-.35 3.38-1.047 1.813-.647 3.343-.914 4.596-.809 3.396.272 5.947 1.599 7.644 3.989-3.037 1.823-4.54 4.377-4.51 7.654.028 2.552.962 4.676 2.799 6.363A9.203 9.203 0 0039 29.318a29.7 29.7 0 01-.713 1.854zM30.5.8c0 2-.738 3.869-2.208 5.597-1.774 2.056-3.92 3.243-6.246 3.056a6.162 6.162 0 01-.047-.758c0-1.92.843-3.976 2.342-5.656.748-.851 1.699-1.559 2.852-2.123C28.343.36 29.432.053 30.456 0a7.2 7.2 0 01.043.8z" })
                        ]),
                        _createElementVNode("defs", null, [
                          _createElementVNode("clipPath", { id: "a2hs-ios_svg__clip0_98_44" }, [
                            _createElementVNode("path", {
                              fill: "#fff",
                              d: "M0 0h40v40H0z"
                            })
                          ])
                        ])
                      ], -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('pwa.webapp')), 1)
                    ]),
                    _: 1,
                    __: [4]
                  })), [
                    [_directive_audio]
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: showIOSPopup.value,
          position: "bottom",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('pwa.ios.title')), 1),
                _withDirectives(_createVNode(_component_van_icon, {
                  class: "close-icon",
                  name: "cross",
                  onClick: _cache[3] || (_cache[3] = $event => (_unref(settingsStore).hideIOSWebApp()))
                }, null, 512), [
                  [_directive_audio, void 0, "close"]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-title" }, "1. Tap on the 'More' icon and then tap on Add to Home Screen", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      class: "guide-step-image",
                      src: require('@/assets/img/pwa/ios1.png'),
                      alt: "step"
                    }, null, 8, _hoisted_15),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "guide-step-text-group1" }, [
                      _createElementVNode("div", { class: "guide-img-text" }, "Add to Quick Note"),
                      _createElementVNode("div", { class: "guide-img-text" }, "Find on Page"),
                      _createElementVNode("div", { class: "guide-img-text" }, "Add to Home Screen"),
                      _createElementVNode("div", { class: "guide-img-text" }, "Markup")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "section-title" }, "2. Click to add, select 'Add'", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      class: "guide-step-image",
                      src: require('@/assets/img/pwa/ios2.png'),
                      alt: "guide"
                    }, null, 8, _hoisted_18),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "guide-step-text-group2--header" }, [
                        _createElementVNode("div", { class: "guide-img-text" }, "Cancel"),
                        _createElementVNode("div", { class: "guide-img-text bold" }, "Add")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_van_image, {
                          class: "logo-img",
                          src: require('@/assets/img/common/logo.png')
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "app-name" }, "GBETNEW.com", -1)),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(appLink.value), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("img", {
                    class: "down-pointer",
                    src: require('@/assets/img/pwa/hand.png'),
                    alt: "pointer"
                  }, null, 8, _hoisted_23)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

}